var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "toolbar" } },
        [
          _c("v-breadcrumbs", {
            attrs: { large: "", items: _vm.breadcrumbs },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-breadcrumbs-item",
                      { attrs: { href: item.href, disabled: item.disabled } },
                      [
                        _c(
                          "span",
                          { class: !item.disabled ? "primary--text" : "" },
                          [_vm._v(" " + _vm._s(item.text) + " ")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("v-divider", {
            staticClass: "mx-4",
            attrs: { vertical: "", inset: "" },
          }),
          _c(
            "v-row",
            {
              staticClass: "flex-nowrap",
              attrs: { align: "center", dense: "" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "flex-nowrap flex-shrink-1",
                  attrs: { align: "start" },
                },
                [
                  _c("span", { staticClass: "text-subtitle-1" }, [
                    _c("span", { staticClass: "font-weight-medium" }, [
                      _vm._v(" Ad Dates: "),
                    ]),
                    _c("span", { staticStyle: { "margin-left": "2px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDateDisplay(
                              _vm.adPlanner && _vm.adPlanner.ad_start_date
                            )
                          ) +
                          " - " +
                          _vm._s(
                            _vm.formatDateDisplay(
                              _vm.adPlanner && _vm.adPlanner.ad_end_date
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-bottom": 3,
                    value: _vm.columnVisability,
                    bottom: "",
                    "offset-y": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on: menu, attrs }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on: tooltip }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "grey lighten-2 ml-2",
                                                on: {
                                                  click:
                                                    _vm.openColumnVisability,
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            { ...tooltip, ...menu }
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-cog-outline"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Column Visability")])]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "fill", attrs: { width: "250" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pb-0 text-subtitle-1" },
                        [_vm._v("Select Visable Headers")]
                      ),
                      _c(
                        "v-card-text",
                        {
                          staticStyle: {
                            "max-height": "500px",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.selectedHeaders, function (header) {
                              return _c(
                                "v-list-item",
                                { key: header.value },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: header.text,
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: header.show,
                                      callback: function ($$v) {
                                        _vm.$set(header, "show", $$v)
                                      },
                                      expression: "header.show",
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        { staticClass: "fill" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: { click: _vm.closeColumnVisability },
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "warning",
                              attrs: {
                                disabled: _vm.selectedHeaders.every(
                                  (header) => header.show == true
                                ),
                              },
                              on: { click: _vm.resetCustomHeaders },
                            },
                            [_vm._v(" Reset ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue white--text mr-2",
                              on: { click: _vm.saveCustomHeaders },
                            },
                            [_vm._v(" Save ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-bottom": 3,
                    value: _vm.bulkEditMenu,
                    bottom: "",
                    "offset-y": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on: menu, attrs }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on: tooltip }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "grey lighten-2 ml-2",
                                                attrs: {
                                                  disabled:
                                                    !_vm.hasSelectedItems ||
                                                    _vm.isEditingDisabled,
                                                  readonly:
                                                    !_vm.hasSelectedItems,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.bulkEditMenu = true
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            { ...tooltip, ...menu }
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                "mdi-pencil-box-multiple-outline"
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Edit")])]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "fill", attrs: { width: "200" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pb-0 text-subtitle-1" },
                        [_vm._v(" Edit ")]
                      ),
                      _c(
                        "v-form",
                        { ref: "form", staticClass: "px-4 pt-4" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: _vm.countRules,
                              "background-color": "input",
                              dense: "",
                              label: "Count",
                              outlined: "",
                              type: "number",
                            },
                            model: {
                              value: _vm.bulkCount,
                              callback: function ($$v) {
                                _vm.bulkCount = $$v
                              },
                              expression: "bulkCount",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              rules: _vm.srpRules,
                              dense: "",
                              outlined: "",
                              "background-color": "input",
                              label: "AD SRP",
                              placeholder: "0.00",
                              prefix: "$",
                              type: "number",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.handleBlur(null, $event)
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.bulkUpdate.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.bulkSRP,
                              callback: function ($$v) {
                                _vm.bulkSRP = $$v
                              },
                              expression: "bulkSRP",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        { staticClass: "fill" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: { click: _vm.closeBulkEdit },
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue white--text mr-2",
                              on: { click: _vm.bulkUpdate },
                            },
                            [_vm._v(" Update ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on: tooltip }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "mx-2",
                                attrs: {
                                  loading: _vm.loading,
                                  disabled: !_vm.hasUnsavedChanges,
                                  color: "success",
                                },
                                on: { click: _vm.saveChanges },
                              },
                              tooltip
                            ),
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-content-save"),
                              ]),
                              _vm._v(" Save "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Save Changes")])]
              ),
              _c(
                "v-col",
                { staticClass: "mx-1 d-flex ml-auto", attrs: { cols: "4" } },
                [
                  _c("SearchFilters", {
                    attrs: {
                      departments: _vm.departments,
                      pages: _vm.pages,
                      feature_text: _vm.feature_text,
                      feature_type: _vm.feature_type,
                      order_page: false,
                    },
                    model: {
                      value: _vm.searchParams,
                      callback: function ($$v) {
                        _vm.searchParams = $$v
                      },
                      expression: "searchParams",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "d-flex shrink" },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        bottom: "",
                        left: "",
                        "offset-y": "",
                        "nudge-bottom": "3",
                        "close-on-content-click": "",
                        "min-width": "200",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on: menu, attrs }) {
                            return [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { left: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on: tooltip }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      disabled: _vm.readOnly,
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                { ...tooltip, ...menu }
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-dots-vertical"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v("Actions")])]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            { on: { click: _vm.exportCSV } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "blue" },
                                },
                                [_vm._v("mdi-file-excel-outline")]
                              ),
                              _vm._v(" Export "),
                            ],
                            1
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                left: "",
                                disabled: !_vm.disableSendToGrid,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "div",
                                        _vm._g({}, on),
                                        [
                                          _c(
                                            "v-list-item",
                                            {
                                              attrs: {
                                                disabled: _vm.disableSendToGrid,
                                              },
                                              on: {
                                                click: _vm.publishToOrderGrid,
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    color: _vm.disableSendToGrid
                                                      ? "grey"
                                                      : "green",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-email-fast-outline"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" Send to Order Grid "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-data-table", {
        ref: "ad-items-table",
        attrs: {
          headers: _vm.displayHeaders,
          height: _vm.tableSize,
          "items-per-page": _vm.pageSize,
          items: _vm.groupedItems,
          "group-by": "groupKey",
          loading: _vm.loading,
          "sort-by": ["page_name", "position_name"],
          "show-select": "",
          dense: "",
          "fixed-header": "",
          "hide-default-footer": "",
          "loading-text": "Loading... Please Wait",
          "no-data-text": "No Retail Ad Items to Display",
          "no-results-text": "No Matches Found",
          "item-key": "ad_plan_id",
        },
        on: {
          "update:items": function ($event) {
            _vm.groupedItems = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: `group.header`,
              fn: function ({ group, headers, items, isOpen, toggle }) {
                return [
                  _c(
                    "td",
                    {
                      staticClass: "blue-grey lighten-2 white--text",
                      staticStyle: {
                        height: "40px",
                        "border-top": "1px solid grey !important",
                      },
                      attrs: { colspan: headers.length },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "", align: "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              ref: group,
                              attrs: {
                                dark: "",
                                small: "",
                                icon: "",
                                "data-open": isOpen,
                              },
                              on: { click: toggle },
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      isOpen
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticClass: "ml-1 font-weight-medium" },
                            [_vm._v(" " + _vm._s(items[0].groupName) + " ")]
                          ),
                          _c("v-divider", {
                            staticClass: "mx-4 mb-1 white",
                            attrs: { inset: "", vertical: "", length: "10" },
                          }),
                          _c("span", [
                            _vm._v(" " + _vm._s(items[0].feature_notes) + " "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: `item.item_desc`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" " + _vm._s(item.item_desc) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.department`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" " + _vm._s(item.department) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.qty_per_case`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" " + _vm._s(item.qty_per_case) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.pack_size`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" " + _vm._s(item.pack_size) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.upc`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" " + _vm._s(item.upc) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.case_cost`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.case_cost)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.net_case_cost`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.net_case_cost)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.amap`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" $" + _vm._s(_vm._f("format")(item.amap)) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.early_buy_billback`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" +
                        _vm._s(_vm._f("format")(item.early_buy_billback)) +
                        " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.dsd_oi_billback`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" +
                        _vm._s(_vm._f("format")(item.dsd_oi_billback)) +
                        " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.ad_billback`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.ad_billback)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.tpr_billback`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.tpr_billback)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.edlc_billback`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.edlc_billback)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.ad_scan`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" $" + _vm._s(_vm._f("format")(item.ad_scan)) + " "),
                  ]),
                ]
              },
            },
            {
              key: `item.epay_ad_scan`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.epay_ad_scan)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.ad_scan_compete`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" +
                        _vm._s(_vm._f("format")(item.ad_scan_compete)) +
                        " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.tpr_scan`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.tpr_scan)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.epay_tpr_scan`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.epay_tpr_scan)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.tpr_scan_compete`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" +
                        _vm._s(_vm._f("format")(item.tpr_scan_compete)) +
                        " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.edlc_scan`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.edlc_scan)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.epay_edlc_scan`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.epay_edlc_scan)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.edlc_scan_compete`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" +
                        _vm._s(_vm._f("format")(item.edlc_scan_compete)) +
                        " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.net_unit_cost`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.net_unit_cost)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.count_and_retail`,
              fn: function ({ item }) {
                return [
                  _c(
                    "td",
                    { staticClass: "px-2" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "my-1 px-2" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 flex-grow-1" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled: _vm.isEditingDisabled,
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  solo: "",
                                  type: "number",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleChange(item, {
                                      target: { value: $event },
                                    })
                                  },
                                },
                                model: {
                                  value: item.ad_retail_count,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      item,
                                      "ad_retail_count",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "item.ad_retail_count",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-icon",
                            { staticClass: "px-2", attrs: { size: "20" } },
                            [_vm._v("mdi-slash-forward")]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 flex-grow-0",
                              attrs: { cols: "5" },
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled: _vm.isEditingDisabled,
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  solo: "",
                                  type: "number",
                                  prefix: "$",
                                  step: "0.01",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleChange(item, {
                                      target: { value: $event },
                                    })
                                  },
                                  blur: function ($event) {
                                    return _vm.handleBlur(item, $event)
                                  },
                                },
                                model: {
                                  value: item.ad_retail,
                                  callback: function ($$v) {
                                    _vm.$set(item, "ad_retail", _vm._n($$v))
                                  },
                                  expression: "item.ad_retail",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 flex-grow-0" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  style: {
                                                    visibility:
                                                      _vm.unsaved_changes.some(
                                                        (change) =>
                                                          change.item_id ===
                                                          item.item_id
                                                      )
                                                        ? "visible"
                                                        : "hidden",
                                                  },
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.undoChanges(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-refresh-circle"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v("Reset Values")])]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: `item.regular_retail`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " $" + _vm._s(_vm._f("format")(item.regular_retail)) + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.last_90_days_shipped_qty`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " " + _vm._s(item.last_90_days_shipped_qty ?? "0") + " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.ad_gross_profit_percent`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("format")(item.ad_gross_profit_percent)) +
                        "% "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.tpr_dates`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.tpr_start_date
                            ? item.tpr_start_date + " - " + item.tpr_end_date
                            : ""
                        ) +
                        " "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.x`,
              fn: function ({ item }) {
                return [
                  _c("td", { staticClass: "noWrap px-2" }, [
                    _vm._v(" $" + _vm._s(_vm._f("format")(item.x)) + " "),
                  ]),
                ]
              },
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c("v-divider"),
                  _c(
                    "v-toolbar",
                    { attrs: { flat: "", color: "toolbar" } },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticStyle: { "max-width": "150px" },
                          attrs: { cols: "2" },
                        },
                        [
                          _c("v-select", {
                            staticClass: "mt-8",
                            attrs: {
                              dense: "",
                              items: _vm.pageSizes,
                              label: "Items Per Page",
                              "menu-props": {
                                top: true,
                                offsetY: true,
                                maxHeight: 500,
                              },
                            },
                            model: {
                              value: _vm.pageSize,
                              callback: function ($$v) {
                                _vm.pageSize = $$v
                              },
                              expression: "pageSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.disablePrevious,
                          },
                          on: { click: _vm.previous },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                        1
                      ),
                      _c("small", [_vm._v("Page " + _vm._s(_vm.page))]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.disableNext,
                          },
                          on: { click: _vm.next },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedItems,
          callback: function ($$v) {
            _vm.selectedItems = $$v
          },
          expression: "selectedItems",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }